import React, { Children } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
  getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

const Container = styled.li`
  border: 1px solid
    ${({
      theme: {
        colors: { hamburgerGrey },
      },
    }) => hamburgerGrey};
  border-radius: 40px;
  display: inline-flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 482px;
  list-style: none;
  margin: 0px;
  margin-right: 75px;
  padding: 0;
  width: 294px;

  @media screen and (min-width: ${getSize("tablet720")}) {
    height: 492px;
    margin-right: 0px;
    width: 300px;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    height: 532px;
    margin-right: 0px;
    width: 324px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    height: 688px;
    margin-right: 0px;
    width: 420px;
  }
`;

const ImageWrapper = styled.div`
  border-bottom: 1px solid ${p => p.theme.colors.hamburgerGrey};
  background-color: ${p => p.theme.colors.barelyGrey};
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: 224px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: ${getSize("tablet720")}) {
    height: 224px;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    height: 240px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    height: 310px;
  }
`;

const EnergyImage = styled.img`
  height: 150px;
  object-fit: contain;
  max-width: 167px;
  pointer-events: none;
  width: auto;
  @media screen and (min-width: ${getSize("tablet720")}) {
    height: 153px;
    pointer-events: initial;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    height: 165px;
    max-width: 180px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    height: 214px;
    max-width: 232px;
  }
`;

const ContentWrapper = styled.ul`
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  border-top: 0px;
  color: ${p => p.theme.colors.blueGrey};
  flex-grow: 1;
  height: 270px;
  list-style: none;
  margin: 0;
  padding: 34px 16px 28px 16px;
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding: 29px 16px 28px 16px;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    padding: 36px 24px 28px 24px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    padding: 45px 32px 28px 32px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    padding: 46px 32px 28px 32px;
  }
`;

const PackageDetailListItem = styled.li`
  font-size: 20px;
  letter-spacing: 0.6px;
  line-height: 23px;
  list-style: none;
  margin: 18px auto;
  padding: 0;
  text-align: center;
  :first-child {
    margin-top: 0;
  }
  :last-child {
    margin-bottom: 0;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    font-size: 27px;
    letter-spacing: 0.81px;
    line-height: 35px;
    margin: 14px auto;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    margin: 13px auto;
  }
  ${getFontFamily("regular")}
`;

export const EnergyPackage = props => {
  const {
    image: { alt, className, src },
    children,
  } = props;

  return (
    <Container>
      <ImageWrapper>
        <EnergyImage alt={alt} className={className} src={src} />
      </ImageWrapper>
      <ContentWrapper>
        {Children.map(children, (child, index) => (
          <PackageDetailListItem key={index}>{child}</PackageDetailListItem>
        ))}
      </ContentWrapper>
    </Container>
  );
};

EnergyPackage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  image: PropTypes.shape({
    alt: PropTypes.string,
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
  }).isRequired,
};
